/**
 * Not Found Page
 * 404 error page
 */

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFoundPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 200px)',
        textAlign: 'center',
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: theme.palette.warning.main, mb: 2 }} />
      <Typography variant="h2" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 4 }}>
        The page you're looking for doesn't exist.
      </Typography>
      <Button className="action-btn process-btn" variant="contained" color="primary" onClick={() => navigate('/home')}>
        Go to Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
